module.exports = __webpack_public_path__ + "static/media/3DPPA40.3b2a8448.jpg";